var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_14",
    "data-name": "Soustraction 14",
    d: "M11.5,23A11.5,11.5,0,0,1,3.368,3.368,11.5,11.5,0,0,1,19.632,19.632,11.426,11.426,0,0,1,11.5,23ZM9.911,11.352a.478.478,0,0,1,.278.054c.117.081.335.231-.035.969l-.69,1.377A2.5,2.5,0,0,0,9.3,15.98a1.827,1.827,0,0,0,1.326.978,3.4,3.4,0,0,0,.66.067,3.522,3.522,0,0,0,2.174-.777.346.346,0,0,0-.339-.587,2.649,2.649,0,0,1-.718.129.5.5,0,0,1-.279-.054c-.117-.081-.333-.232.037-.967l.691-1.377a2.514,2.514,0,0,0,.169-2.228,1.83,1.83,0,0,0-1.327-.978,3.293,3.293,0,0,0-.662-.067,3.5,3.5,0,0,0-2.173.778.345.345,0,0,0,.34.586l.006,0A2.659,2.659,0,0,1,9.911,11.352Zm2.547-5.6a1.917,1.917,0,1,0,1.917,1.916A1.919,1.919,0,0,0,12.458,5.75Z",
    fill: "#45434d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.03659094.svg";
export { ForwardRef as ReactComponent };